import { render, staticRenderFns } from "./HolographicLine.vue?vue&type=template&id=2d6d4d90&scoped=true"
import script from "./HolographicLine.vue?vue&type=script&lang=js"
export * from "./HolographicLine.vue?vue&type=script&lang=js"
import style0 from "./HolographicLine.vue?vue&type=style&index=0&id=2d6d4d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d4d90",
  null
  
)

export default component.exports